import { LoaderFunctionArgs } from "react-router-dom";
import API from "../../../utils/api";
import { ApiKeychainSchema } from "../../../utils/types";
import { useAuth } from "../../../context/AuthContext";

const ITEMS_PER_PAGE = 20;

export default function DashboardApiKeychainsPageLoader() {
  return async ({ request, params }: LoaderFunctionArgs) => {
    const user = API.user;
    if (!user?.memberships?.[0]?.organization) {
      throw new Error('No organization found');
    }
    const url = new URL(request.url);
    const organization = user.memberships[0].organization.name;
    const page = parseInt(url.searchParams.get('p') || '1', 10);
    const offset = Math.max(0, (page - 1) * ITEMS_PER_PAGE);
    const response = await API.get('v1/api_keychains', {
      organization,
      usage_type: 'standalone',
      __offset: offset,
      __count: ITEMS_PER_PAGE,
    });
    if (!response) {
      throw new Error('Failed to fetch API keychains');
    }
    return {
      apiKeychains: response.data as Array<ApiKeychainSchema>,
      pagination: {
        currentPage: page,
        totalPages: Math.ceil(response.meta.total / ITEMS_PER_PAGE),
      }
    };
  };
}
